function fade(element) {
    var op = 0;
    var timer = setInterval(function() {
        if (op >= 1) clearInterval(timer);
        element.style.opacity = op;
        element.style.filter = 'alpha(opacity=' + op * 100 + ")";
        op += op * 0.1 || 0.1;
    }, 50);
}

// add animate.css class(es) to the elements to be animated
function setAnimation ( _elem, _InOut ) {
    // Store all animationend event name in a string.
    // cf animate.css documentation
    var animationEndEvent = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';

    _elem.each ( function () {
      var $elem = $(this);
      var $animationType = 'animated ' + $elem.data( 'animation-' + _InOut );

      $elem.addClass($animationType).one(animationEndEvent, function () {
        $elem.removeClass($animationType); // remove animate.css Class at the end of the animations
      });
    });
}
// REL is used from the inputs that user check
// INPUT is used where to store them
function store_elements_from_rel_to_input(rel) {
    var tags = [];
    $("input:checked[rel='" + rel + "']").each(function(){
        tags.push($(this).val());
    });
    $("input[name='" + rel + "']").val(tags.join(','));
}

// ID is used from the select that user changed
// INPUT is used where to store them
function store_elements_from_select_to_input(name) {
    var values=[];
    $("#" + name + " option:selected").each(function(){
        values.push($(this).val());
    });
    $("input[name='" + name + "']").val(values.join(','));  
}

var load_more_properties = true;

function populateMoreProperties(){
    if($("#load_can_load_more").val() == "true"){
      load_more_properties = false;
      $('#loading-properties').show();
      var ajax_url = $("#load_ajax_route").val();
      var category_holder = $("#load_container").val();
      var current_value = parseInt($("#load_skip").val());
      current_value += 16;
      $("#load_skip").val(current_value);
      ajax_url = ajax_url.replace("#currentValue#", current_value);
      $.ajax({
        url: ajax_url,
        type: "GET",
        success: function(data){
          if(data.hideMore){
            $("#load_can_load_more").val('false');
            load_more_properties = false;
          }else{
            load_more_properties = true;
          }
            $(category_holder).append(data.data);
            $('#loading-properties').hide();
        }
      });
    }
}

var user_wants_more_properties = false;
$(document).ready(function(){
    $('.datepicker').datepicker({
        dateFormat: 'yy-mm-dd'
    });
    /* Newsletter communication with modal contact link via URL */
    if (location.search.indexOf('show_modal=true') > 0) {
        $('#contact_page').click();
    }
    /* END */
    
    $.ajaxSetup(
    {
        headers:
        {
            'X-CSRF-Token': $('meta[name="csrf-token"]').attr("content")
        }
    });

    // Save as favorite
    $(".save-as-favorite").click(function(){
        var property_id = $(this).attr('rel');
        var i_element = $(this).find(".fa");
        if(i_element.hasClass('fa-star')){
            i_element.removeClass('fa-star').addClass('fa-star-o');
            $(".same-icons-change .fa.fa-star").removeClass('fa-star').addClass('fa-star-o');
        }else{
            i_element.removeClass('fa-star-o').addClass('fa-star');
            $(".same-icons-change .fa.fa-star-o").removeClass('fa-star-o').addClass('fa-star');
        }
        $.ajaxSetup(
        {
            headers:
            {
                'X-CSRF-Token': $('meta[name="csrf-token"]').attr("content")
            }
        });
        $.ajax({
            url:'/save_as_favorite',
            type:'POST',
            data:{property_id: property_id},
            success:function(data){
                $("#save_to_favorites_message").html(data).show().delay(5000).fadeOut();
            },
            error: function (data) {
            }
        });
    });
    // Setup isScrolling variable
    var isScrolling;

    // Listen for scroll events
    window.addEventListener('scroll', function ( event ) {

        // Clear our timeout throughout the scroll
        window.clearTimeout( isScrolling );

        // Set a timeout to run after scrolling ends
        isScrolling = setTimeout(function() {
            var loader_appeared = $('.button-view-more-portfolio').is(':appeared');
            if (loader_appeared == true && load_more_properties == true) {
                populateMoreProperties();
            }
        }, 1000);

    }, false);

    // Bookmark this
    $('#bookmark-this').click(function(e) {
        var bookmarkURL = window.location.href;
        var bookmarkTitle = document.title;

        if ('addToHomescreen' in window && addToHomescreen.isCompatible) {
          // Mobile browsers
          addToHomescreen({ autostart: false, startDelay: 0 }).show(true);
        } else if (window.sidebar && window.sidebar.addPanel) {
          // Firefox <=22
          window.sidebar.addPanel(bookmarkTitle, bookmarkURL, '');
        } else if ((window.sidebar && /Firefox/i.test(navigator.userAgent)) || (window.opera && window.print)) {
          // Firefox 23+ and Opera <=14
          $(this).attr({
            href: bookmarkURL,
            title: bookmarkTitle,
            rel: 'sidebar'
          }).off(e);
          return true;
        } else if (window.external && ('AddFavorite' in window.external)) {
          // IE Favorites
          window.external.AddFavorite(bookmarkURL, bookmarkTitle);
        } else {
          // Other browsers (mainly WebKit & Blink - Safari, Chrome, Opera 15+)
          alert('Press ' + (/Mac/i.test(navigator.userAgent) ? 'Cmd' : 'Ctrl') + '+D to bookmark this page.');
        }

        return false;
      });


    $('#owl_featured_products').owlCarousel({
        loop: true,
        items: 1,
        nav: true,
        autoplay:false,
        autoplayTimeout:1000,
        lazyLoad: true,
        animateIn: true,
        navText: ["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"]
    });


    $('#owl_videos_of_the_month').owlCarousel({
        loop: true,
        items: 1,
        nav: true,
        autoplay:false,
        autoplayTimeout:1000,
        lazyLoad: true,
        animateIn: true,
        navText: ["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"]
    });

    $("#testimonials-carousel").owlCarousel({
        loop: true,
        items: 3,
        nav: true,
        autoplay:true,
        autoplayTimeout:4000,
        autoHeight:true,
        lazyLoad: true,
        animateIn: true,
        navText: ["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"],
        responsiveClass:true,
        responsive:{
            0:{
                items:1,
                nav:true
            },
            1000:{
                items:3,
                nav:true,
                loop:false
            }
        }
    });

    var checkWidth = $(document).width();
    if(checkWidth >= 768){
        $('#owl_similar_products').owlCarousel({
            loop: true,
            items: 2,
            nav: true,
            autoplay:false,
            autoplayTimeout:1000,
            lazyLoad: true,
            animateIn: true,
            navText: ["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"]
        });
    }


    if($('#owl-carousel_header').length > 0){
        var owl = $('#owl-carousel_header');
        owl.owlCarousel({
            items: 1,
            loop: true,
            autoplay:true,
            autoplayTimeout:5000,
            nav: true,
            lazyLoad: true,
            animateIn: true,
            navText: ["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"],
        });
        // Fired before current slide change
        owl.on('change.owl.carousel', function(event) {
            var $currentItem = $('.owl-item', owl).eq(event.item.index);
            var $elemsToanim = $currentItem.find("[data-animation-out]");
            setAnimation ($elemsToanim, 'out');
        });

        // Fired after current slide has been changed
        owl.on('changed.owl.carousel', function(event) {
            var $currentItem = $('.owl-item', owl).eq(event.item.index);
            var $elemsToanim = $currentItem.find("[data-animation-in]");
            setAnimation ($elemsToanim, 'in');
        });
    }
    // SAVE SEARCH FORM
    $(".save-search").click(function(e) {
        storeElements();
        var formData =  $('#filter-form').serialize();
        var href_save = '/search?'+ formData;
        $.ajax({
            url:'/search',
            type:'POST',
            data:{search_url: href_save, language: $('#language_name').val()},
            success:function(data){
                location = href_save;
            },
            error: function (data) {
            }
        });
    });
    // 
    $(".close-register").click(function(){
        $("#register-modal").modal('hide');
    });
    
    $(".close-login").click(function(){
        $("#login-modal").modal('hide');
    });

    $('.close-login-save-search').click(function(){
        storeElements();
        var formData =  $('#filter-form').serialize();
        var href_save = '/search?'+ formData;
        createCookie('saveSearch', href_save, 1);

        $("#login-save-search-modal").modal('hide');
    });
    // LOGIN FORM
    $(".form-login").on("submit", function(e) {
        e.preventDefault();
        var formData =  $(this).serialize();

        $.ajax({
            url:'login',
            type:'POST',
            data:formData,
            success:function(data){
                if(readCookie('saveSearch')){
                    $.ajax({
                        url:'/search',
                        type:'POST',
                        data:{search_url: readCookie('saveSearch'), language: $('#language_name').val()},
                        success:function(data){
                            var href_redirect = readCookie('saveSearch');
                            eraseCookie('saveSearch');
                            location = href_redirect;
                        },
                        error: function (data) {
                        }
                    });
                }else{
                    location.reload();
                }
            },
            error: function (data) {
                $('.form-login .alert').remove();
                $('.form-login').prepend("<div class='alert alert-danger'></div>");
                $.each(data.responseJSON, function(a, i) {
                    $(".form-login .alert").append("<p>"+ i +"</p>");
                });
            }
        });
    });

    // LOGIN FORM SAVE SEARCH
    $(".form-login-save-search").on("submit", function(e) {
        e.preventDefault();
        var formData =  $(this).serialize();
        
        storeElements();
        var formDataSave =  $('#filter-form').serialize();
        var href_save = '/search?'+ formDataSave;

        $.ajax({
            url:'login',
            type:'POST',
            data:formData,
            success:function(data){
                $.ajax({
                    url:'/search',
                    type:'POST',
                    data:{search_url: href_save, language: $('#language_name').val()},
                    success:function(data){
                        location = href_save;
                    }
                });
            },
            error: function (data) {
                $('.form-login-save-search .alert').remove();
                $('.form-login-save-search').prepend("<div class='alert alert-danger'></div>");
                $.each(data.responseJSON, function(a, i) {
                    $(".form-login-save-search .alert").append("<p>"+ i +"</p>");
                });
            }
        });
    });

    // REGISTER FORM
    $("#form-register").on("submit", function(e) {
        e.preventDefault();
        var fields = $(this).serialize();

        $.ajax({
            type: "POST",
            url: $(this).attr('action'),
            dataType: "JSON",
            data: fields,
            success: function(data) {
                $('#form-register' + ' .alert').remove();
                $('#form-register').prepend("<div class='alert alert-success'>"+ data +"</div>");
                if(readCookie('saveSearch').length > 1){
                    $.ajax({
                        url:'/search',
                        type:'POST',
                        data:{search_url: readCookie('saveSearch'), language: $('#language_name').val()},
                        success:function(data){
                            var href_redirect = readCookie('saveSearch');
                            eraseCookie('saveSearch');
                            location = href_redirect;
                        },
                        error: function (data) {
                        }
                    });
                }else{
                    location.reload();
                }
            },
            error: function(data) {
                $('#form-register' + ' .alert').remove();
                $('#form-register').prepend("<div class='alert alert-danger'></div>");
                $.each(data.responseJSON, function(a, i) {
                    $('#form-register' + " .alert").append("<p>"+ i +"</p>");
                });
            }
        }); 
    });

    // Contact Form
    $("#form-contacts").on("submit", function(e) {
        e.preventDefault();
        var fields = $(this).serialize();

        $.ajax({
            type: "POST",
            url: '/contacts',
            dataType: "JSON",
            data: fields,
            success: function(data) {
                $('#form-contacts' + ' .alert').remove();
                $('#form-contacts').prepend("<div class='alert alert-success'>"+ data +"</div>");
                document.getElementById("form-contacts").reset();
            },
            error: function(data) {
                $('#form-contacts' + ' .alert').remove();
                $('#form-contacts').prepend("<div class='alert alert-danger'></div>");
                $.each(data.responseJSON, function(a, i) {
                    $('#form-contacts' + " .alert").append(i +"<br/>");
                });
            }
        }); 
    });
    // Skipass Form
    $("#form-skipass").on("submit", function(e) {
        e.preventDefault();
        var fields = $(this).serialize();

        $.ajax({
            type: "POST",
            url: '/skipass',
            dataType: "JSON",
            data: fields,
            success: function(data) {
                $('#form-skipass' + ' .alert').remove();
                $('#form-skipass').prepend("<div class='alert alert-success'>"+ data +"</div>");
                document.getElementById("form-skipass").reset();
            },
            error: function(data) {
                $('#form-skipass' + ' .alert').remove();
                $('#form-skipass').prepend("<div class='alert alert-danger'></div>");
                $.each(data.responseJSON, function(a, i) {
                    $('#form-skipass' + " .alert").append(i +"<br/>");
                });
            }
        }); 
    });


    // Apply for job Form
    $("#form-jobs").on("submit", function(e) {
        e.preventDefault();
          $.ajax({
            type:"POST",
            url:'/apply_for_job',
            data: new FormData($(this)[0]),
            dataType: 'HTML',
            processData:false,
            contentType: false,
            headers: { 'X-CSRF-TOKEN': $(this).find('input[name="_token"]').val() },
            success: function(data){
                $('#form-jobs' + ' .alert').remove();
                $('#form-jobs').prepend("<div class='alert alert-success'>"+ data +"</div>");
                document.getElementById("form-jobs").reset();
            },
            error: function(data){
                $('#form-jobs' + ' .alert').remove();
                $('#form-jobs').prepend("<div class='alert alert-danger'></div>");
                $.each(JSON.parse(data.responseText), function(a, i) {
                    $('#form-jobs' + " .alert").append(i +"<br/>");
                });
            }
          });
    });


    //CHANGE LANGUAGE
    $('.change-language').click(function(){
        var new_host = $(this).attr('rel');
        var pathArray = window.location.pathname.split( '/' );
        var language = $(this).text();
        var newPathname = new_host;
        if(pathArray[1] == 'en' || pathArray[1] == 'ro' || pathArray[1] == 'uk'){
            pathArray[1] = $(this).attr('rel');
        }else if(pathArray[0] == ''){
            pathArray[0] = $(this).attr('rel');
        }
        $url = pathArray.join("/");
        if(!$url.indexOf('/') == 0) {
            $url = "/"+$url;
        }
        console.log($url);
        // window.location.href = pathArray.join("/");
    });

    // Property Evaluator
    $("#form-property-evaluators").on("submit", function(e) {
        e.preventDefault();
        var fields = $(this).serialize();

        $.ajax({
            type: "POST",
            url: '/property_evaluators',
            dataType: "JSON",
            data: fields,
            success: function(data) {
                $('#form-property-evaluators' + ' .alert').remove();
                $('#form-property-evaluators').prepend("<div class='alert alert-success'>"+ data +"</div>");
                document.getElementById("form-property-evaluators").reset();
            },
            error: function(data) {
                $('#form-property-evaluators' + ' .alert').remove();
                $('#form-property-evaluators').prepend("<div class='alert alert-danger'></div>");
                $.each(data.responseJSON, function(a, i) {
                    $('#form-property-evaluators' + " .alert").append("<p>"+ i +"</p>");
                });
            }
        }); 
    });
	
	if ($(this).scrollTop() > 500) {
		$('.bg-scroll').css('background', 'rgba(0,0,0,0.6)');
	}else{
		$('.bg-scroll').css('background', 'rgba(0,0,0,0)');
	}

	$(window).scroll(function() {
		if ($(this).scrollTop() > 500) {
			$('.bg-scroll').css('background', 'rgba(0,0,0,0.6)');
		}else{
			$('.bg-scroll').css('background', 'rgba(0,0,0,0)');
		}
	});
    // Selectize
    $('.selectize').selectize({
        delimiter: ',',
        plugins: ['remove_button']
    });

    $('.location_selectize').selectize({
        plugins: ['remove_button']
    });
    // Selectize for locations
    if($('#regions').length > 0 && $('#cities').length > 0 && $('#zones').length > 0) {

        var select_region, $select_region;
        var select_city, $select_city;
        var select_zone, $select_zone;

        $select_region = $('#regions').selectize({
            searchField: 'name',
            plugins: ['remove_button'],
            onChange: function(value) {
                select_city.disable();
                select_city.clearOptions();
                select_city.load(function(callback_cities) {
                    $.ajax({
                        url: '/ajaxCities?id=' + value,
                        success: function(results) {
                            select_city.enable();
                            callback_cities(results);
                        },
                        error: function() {
                            callback_cities();
                        }
                    })
                });
                // Append values to zone select based on selected region
                select_zone.disable();
                select_zone.clearOptions();
                select_zone.load(function(callback_zones) {
                    $.ajax({
                        url: '/ajaxZones?region_id=' + value,
                        success: function(results) {
                            select_zone.enable();
                            callback_zones(results);
                        },
                        error: function() {
                            callback_zones();
                        }
                    })
                });
            }
        });

        $select_city = $('#cities').selectize({
            searchField: 'name',
            valueField: 'id',
            labelField: 'name',
            plugins: ['remove_button'],
            onChange: function(value) {
                console.log(value);
                // Append values to zone select based on selected region
                select_zone.disable();
                select_zone.clearOptions();
                select_zone.load(function(callback_zones) {
                    $.ajax({
                        url: '/ajaxZones?cities=' + value,
                        success: function(results) {
                            select_zone.enable();
                            callback_zones(results);
                        },
                        error: function() {
                            callback_zones();
                        }
                    })
                });
            }
        });

        $select_zone = $('#zones').selectize({
            searchField: 'name',
            valueField: 'id',
            labelField: 'name',
            plugins: ['remove_button']
        });

        select_city  = $select_city[0].selectize;
        select_zone  = $select_zone[0].selectize;
        select_region = $select_region[0].selectize;
    }

    // Change transaction type
    if($('#transaction_type-field').length > 0)
        $select_transaction_type = $('#transaction_type-field').selectize({
            onChange: function(value) {
                $( "#slider-range-price" ).slider( "option", "max", $('#'+value+"_max_price_default").val());
                $( "#slider-range-price" ).slider( "option", "step", $('#'+value+"_max_price_default").data('step'));
                $( "#price-amount" ).html( "€" + $( "#slider-range-price" ).slider( "values", 0 ) +
                    " - €" + $( "#slider-range-price" ).slider( "values", 1 ) );
            }
        });

    // Change property type
    if($('#property_type').length > 0)
        $select_property_type = $('#property_type').selectize({
            onChange: function(value) {
                var selected_property_type = $("#contains-property-type-plural-"+value).val();
                $(".search-more-trigger-button").removeClass('hide');
                $('.filter-area.current-filter-area').attr('class', 'filter-area current-filter-area ' + selected_property_type);
            }
        });
    // Change land type
    if($('#land_type').length > 0)
        $select_land_type = $('#land_type').selectize();
    // Change land clasification
    if($('#land_clasification').length > 0)
        $select_land_clasification = $('#land_clasification').selectize();
    // Change land clasification
    if($('#commercial_building_type').length > 0)
        $commercial_building_type = $('#commercial_building_type').selectize();
    // ------------------
    // ------------------
    // SEARCH FORM FILTER
    // ------------------
    // ------------------
    $('#filter-form').on("submit",function(e) {
        // // ADD cities in one parameter only
        // store_elements_from_select_to_input('cities');
        // // ADD zones in one parameter only
        // store_elements_from_select_to_input('zones');
        // // ADD rooms in one parameter only
        // store_elements_from_select_to_input('rooms');
        // // ADD bathrooms in one parameter only
        // store_elements_from_select_to_input('bathrooms');

        // // ADD industrials tags in one parameter only
        // store_elements_from_rel_to_input('industrials-tags');
        // // ADD lands tags in one parameter only
        // store_elements_from_rel_to_input('lands-tags');
        // // ADD commercials tags in one parameter only
        // store_elements_from_rel_to_input('commercials-tags');
        // // ADD offices tags in one parameter only
        // store_elements_from_rel_to_input('offices-tags');
        // // ADD apartments tags in one parameter only
        // store_elements_from_rel_to_input('app-tags');

        // // ADD comfort in one parameter only
        // store_elements_from_rel_to_input('comfort');

        // // ADD interior_state in one parameter only
        // store_elements_from_rel_to_input('interior_state');

        // // ADD partition in one parameter only
        // store_elements_from_rel_to_input('partition');  
    });

    $("#properties-order").change(function(e){
        
        var rel = $(this).val();
        var url = $(location).attr('href');
        if(url.indexOf("region_id") > -1) {
            if(url.indexOf("sort") > -1){
                var regEx = /([?&]sort)=([^#&]*)/g;
                var newurl = url.replace(regEx, '$1='+rel);
            }else{
                var newurl = url + "&sort=" + rel;
            }
        }else{
            if(url.indexOf("sort") > -1){
                var regEx = /([?&]sort)=([^#&]*)/g;
                var newurl = url.replace(regEx, '$1='+rel);
            }else{
                var newurl = url + "?sort=" + rel;
            }
        }
        $(location).attr('href', newurl);
    });
});

$( window ).on( "load", function() {
    if($('#owl-carousel-images-property').find('.item-video')){
        var thumb_video = $('#owl-carousel-images-property').find('.item-video').find('.owl-video-tn').data('src');
        var img_video = $('#owl-carousel-images-property .owl-thumbs .owl-thumb-item').last().find('img');
        img_video.attr('src', thumb_video);
    }
});

( function ( $ ) {
    // Create a new instance of Slidebars
    var controller = new slidebars();
    // Initialize Slidebars
    controller.init();

    // Right Slidebar controls
    $( '.js-open-right-slidebar').on( 'click', function ( event ) {
        event.stopPropagation();
        $('body').addClass('offcanvas-open');
        controller.open( 'slidebar-2' );
    } );

    $( '.offcanvas-close' ).on( 'click', function ( event ) {
        event.stopPropagation();
        $('body').removeClass('offcanvas-open');
        controller.close( 'slidebar-2' );
    } );
    $( '.close-menu' ).on( 'click', function ( event ) {
        $('body').removeClass('offcanvas-open');
        controller.close( 'slidebar-2' );
    } );

    $( '.js-toggle-right-slidebar' ).on( 'click', function ( event ) {
        event.stopPropagation();
        $('body').addClass('offcanvas-open');
        controller.toggle( 'slidebar-2' );
    } );

    
} ) ( jQuery );


function storeElements(){
    // ADD cities in one parameter only
        store_elements_from_select_to_input('cities');
        // ADD zones in one parameter only
        store_elements_from_select_to_input('zones');
        // ADD rooms in one parameter only
        store_elements_from_select_to_input('rooms');
        // ADD bathrooms in one parameter only
        store_elements_from_select_to_input('bathrooms');

        // ADD industrials tags in one parameter only
        store_elements_from_rel_to_input('industrials-tags');
        // ADD lands tags in one parameter only
        store_elements_from_rel_to_input('lands-tags');
        // ADD commercials tags in one parameter only
        store_elements_from_rel_to_input('commercials-tags');
        // ADD offices tags in one parameter only
        store_elements_from_rel_to_input('offices-tags');
        // ADD apartments tags in one parameter only
        store_elements_from_rel_to_input('app-tags');

        // ADD comfort in one parameter only
        store_elements_from_rel_to_input('comfort');

        // ADD interior_state in one parameter only
        store_elements_from_rel_to_input('interior_state');

        // ADD partition in one parameter only
        store_elements_from_rel_to_input('partition');  
}

function createCookie(name,value,days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        var expires = "; expires="+date.toGMTString();
    }
    else var expires = "";
    document.cookie = name+"="+value+expires+"; path=/";
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name,"",-1);
}